// ACTIONS
const INITIALISE_CANDIDATE = 'candidateExperience/INITIALISE_CANDIDATE'

const SET_LOADING = 'offerzen/candidate/SET_LOADING'

export const UPDATE_CANDIDATE = 'offerzen/candidate/UPDATE_CANDIDATE'
export const CONFIRM_DETAILS_CANDIDATE = 'offerzen/candidate/CONFIRM_DETAILS_CANDIDATE'
const UPDATE_CANDIDATE_SUCCESS = 'offerzen/candidate/UPDATE_CANDIDATE_SUCCESS'

export const WRAP_UP = 'offerzen/candidate/WRAP_UP'

export const CREATE_CANDIDATE = 'offerzen/candidate/CREATE_CANDIDATE'
const CREATE_CANDIDATE_SUCCESS = 'offerzen/candidate/CREATE_CANDIDATE_SUCCESS'
const CREATE_CANDIDATE_FAILED = 'offerzen/candidate/CREATE_CANDIDATE_FAILED'

// ACTION CREATORS
export const initialiseCandidate = initialState => ({
  type: INITIALISE_CANDIDATE,
  payload: initialState,
})

export const setLoading = () => ({
  type: SET_LOADING,
  payload: {
    loading: true,
  },
})

export const updateCandidate = (candidate, nextRoute = null) => ({
  type: UPDATE_CANDIDATE,
  payload: {
    candidate,
    nextRoute,
    loading: true,
  },
})

export const confirmDetailsCandidate = (candidate, nextRoute = null) => ({
  type: CONFIRM_DETAILS_CANDIDATE,
  payload: {
    candidate,
    nextRoute,
    loading: true,
  },
})

export const wrapUpCandidate = (candidate, nextRoute = null) => ({
  type: WRAP_UP,
  payload: {
    candidate,
    loading: true,
  },
})

export const updateCandidateSuccess = candidate => ({
  type: UPDATE_CANDIDATE_SUCCESS,
  payload: {
    candidate,
    loading: false,
  },
})

export const createCandidate = (candidate, refetchCurrentUser) => ({
  type: CREATE_CANDIDATE,
  meta: { refetchCurrentUser },
  payload: {
    candidate,
    loading: true,
  },
})

export const createCandidateSuccess = candidate => ({
  type: CREATE_CANDIDATE_SUCCESS,
  payload: {
    candidate,
    loading: false,
  },
})

export const createCandidateFailed = (error, provider = 'email', authState = null) => ({
  type: CREATE_CANDIDATE_FAILED,
  payload: {
    error: error || "We're sorry! Something went wrong. Please try again",
    loading: false,
    provider,
    authState,
  },
})

// REDUCERS
const candidateReducer = (state = {}, action) => {
  switch (action.type) {
    case INITIALISE_CANDIDATE:
      return {
        ...state,
        ...action.payload,
      }

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case CREATE_CANDIDATE_FAILED:
      return {
        ...state,
        error: action.payload.error,
        provider: action.payload.provider,
        authState: action.payload.authState,
        loading: action.payload.loading,
      }

    case CREATE_CANDIDATE_SUCCESS:
      return {
        ...state,
        ...action.payload.candidate.candidate,
        loading: action.payload.loading,
      }

    case CREATE_CANDIDATE:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case WRAP_UP:
    case UPDATE_CANDIDATE:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case UPDATE_CANDIDATE_SUCCESS:
      return {
        ...state,
        ...action.payload.candidate.candidate,
        loading: action.payload.loading,
      }

    default:
      return state
  }
}

export default candidateReducer
